const appointmentActionPreviousPrice = {
  price: {
    label: "Prix",
    invalid: {}
  },
  quantityCredit: {
    label: "Crédit",
    invalid: {}
  },
  modifiedAt: {
    label: "Date",
    invalid: {}
  },
};

export default appointmentActionPreviousPrice;
